<template>
  <div>
    <Header />
   
    <PageContainer> 
      <div class="iqos-grid">
        <div class="iqos-column">
          <OwnersBotPanel />
        </div>
        <div class="iqos-column">
          <ReminderTimeoutPanel />
          <RegularReportPanel v-show="false"/>
        </div>
      </div>
    </PageContainer>
  </div>
</template>

<script>
import OwnersBotPanel from "@/components/workers/OwnersBotPanel.vue";
import WorkersTelegram from "@/components/workers/WorkersTelegram.vue";
import WorkersQueueID from "@/components/workers/WorkersQueueID.vue";
import RegularReportPanel from "@/components/settings/RegularReportPanel.vue"

import ReminderTimeoutPanel from "@/components/general/ReminderTimeoutPanel.vue"

export default {
  components: {
    OwnersBotPanel,
    WorkersQueueID,
    WorkersTelegram,
    ReminderTimeoutPanel,
    RegularReportPanel
  },
};
</script>

<style></style>
